import { Component, AfterViewInit, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Config } from '@config';
import { StateService, States, StateSubscription } from '@state';
import { RoutePrivilegeNames } from '@route-privilege-names';
import { HistoryListComponent } from './history-list.component';

@Component({
    selector: 'history-page',
    templateUrl: './history.template.html',
    standalone: false
})
export class HistoryComponent implements OnInit, OnDestroy {
    showDatapointHistory: boolean = false;
    showCommandHistory: boolean = false;

    private datapointHistoryComponent: HistoryListComponent

    @ViewChild('datapointHistory', {static: false})
    set datapointHistoryGrid(component: HistoryListComponent) {
        this.datapointHistoryComponent = component;
    }

    private commandHistoryComponent: HistoryListComponent

    @ViewChild('commandHistory', {static: false})
    set commandHistoryGrid(component: HistoryListComponent) {
        this.commandHistoryComponent = component;
    }

    public enableUITwo = false;
    constructor(
        public config: Config,
        private stateService: StateService
    ){
        const themeConfig = this.stateService.value(States.themeConfig).get();
        this.enableUITwo = themeConfig.enableUITwo || false;
    }

    private privilegesChanged(privileges: {name: string, type: string}[]) {
        this.showDatapointHistory = !!privileges?.find(p => p.type === 'plant' && p.name === RoutePrivilegeNames.ChangeDataPoints);
        this.showCommandHistory = !!privileges?.find(p => p.type === 'plant' && p.name === RoutePrivilegeNames.PlantUpgrade);
    }

    public refresh() {
        if (this.datapointHistoryComponent !== null) {
            this.datapointHistoryComponent.refresh();
        }
        if (this.commandHistoryComponent !== null) {
            this.commandHistoryComponent.refresh();
        }
    }

    private privilegesSubscription: StateSubscription;

    ngOnInit(): void {
        this.privilegesSubscription = this.stateService.value(States.privileges).subscribe(privileges => this.privilegesChanged(privileges), true);
    }

    ngOnDestroy(): void {
        this.stateService.unsubscribe(this.privilegesSubscription);
    }
}
